// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/auth/LoginPage.css */

.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #334155 100%);
  padding: 20px;
  box-sizing: border-box;
}

.login-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 400px;
  overflow: hidden;
}

.login-header {
  padding: 40px 32px 24px;
  text-align: center;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
}

.login-logo {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.login-subtitle {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
}

.login-error {
  margin: 16px 32px 0;
  padding: 12px 16px;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  border-radius: 8px;
  color: #DC2626;
  font-size: 13px;
  line-height: 1.5;
}

.login-form {
  padding: 32px;
}

.login-form .form-field {
  margin-bottom: 20px;
}

.login-form .form-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.login-form .form-field input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #E5E7EB;
  border-radius: 10px;
  font-size: 15px;
  color: #1F2937;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.login-form .form-field input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
}

.login-form .form-field input::placeholder {
  color: #9CA3AF;
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
}

.login-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #D97706 0%, #B45309 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-footer {
  padding: 0 32px 24px;
  text-align: center;
}

.toggle-btn {
  background: none;
  border: none;
  color: #6B7280;
  font-size: 13px;
  cursor: pointer;
  padding: 8px;
}

.toggle-btn:hover {
  color: #D97706;
}
`, "",{"version":3,"sources":["webpack://./src/auth/LoginPage.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* src/auth/LoginPage.css */\n\n.login-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #334155 100%);\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.login-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 400px;\n  overflow: hidden;\n}\n\n.login-header {\n  padding: 40px 32px 24px;\n  text-align: center;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n}\n\n.login-logo {\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  letter-spacing: -0.5px;\n}\n\n.login-subtitle {\n  font-size: 14px;\n  margin: 0;\n  opacity: 0.9;\n}\n\n.login-error {\n  margin: 16px 32px 0;\n  padding: 12px 16px;\n  background: #FEF2F2;\n  border: 1px solid #FECACA;\n  border-radius: 8px;\n  color: #DC2626;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.login-form {\n  padding: 32px;\n}\n\n.login-form .form-field {\n  margin-bottom: 20px;\n}\n\n.login-form .form-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.login-form .form-field input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #E5E7EB;\n  border-radius: 10px;\n  font-size: 15px;\n  color: #1F2937;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n}\n\n.login-form .form-field input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);\n}\n\n.login-form .form-field input::placeholder {\n  color: #9CA3AF;\n}\n\n.login-btn {\n  width: 100%;\n  padding: 14px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 8px;\n}\n\n.login-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #D97706 0%, #B45309 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);\n}\n\n.login-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.login-footer {\n  padding: 0 32px 24px;\n  text-align: center;\n}\n\n.toggle-btn {\n  background: none;\n  border: none;\n  color: #6B7280;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 8px;\n}\n\n.toggle-btn:hover {\n  color: #D97706;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
